import React, {Component} from 'react'
import PropTypes from 'prop-types'
import SortableTree, {addNodeUnderParent, changeNodeAtPath} from 'react-sortable-tree'
import FileExplorerTheme from 'react-sortable-tree-theme-file-explorer'
import gql from 'graphql-tag'
import {graphql} from 'react-apollo'
import {Button} from 'reactstrap'
import BlockWithLoader from '../Support/BlockWithLoader'

class ProjectListTree extends Component {

  constructor(props) {
    super(props)
    this.state = {treeData: [], refresh: false}

    this.handleToggle = this.handleToggle.bind(this)
    this.refreshProjects = this.refreshProjects.bind(this)
  }

  static propTypes = {
    data: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    loadElements: PropTypes.func.isRequired
  }

  componentWillReceiveProps(nextProps) {
    if (this.props === nextProps) {
      return
    }

    if (this.state.treeData.length === 0 || this.state.refresh) {
      if (nextProps.data.projects) {
        let projects = nextProps.data.projects.list.map(a => Object.assign({}, a))
        this.setState({treeData: this.decorateArrObject(projects), refresh: false})
      }
    }
  }

  decorateArrObject(arrObject) {
    return arrObject.map(function (value) {
      if (value.children_count > 0) {
        value.children = []
        value.isDirectory = true
        value.children.push({name: 'Elements loading...'})
      }
      return value
    })
  }

  addNodeToTree(path, newNode) {
    this.setState(state => ({
      treeData: addNodeUnderParent({
        treeData: state.treeData,
        parentKey: path[path.length - 1],
        expandParent: true,
        getNodeKey: this.getNodeKey,
        newNode: newNode,
      }).treeData,
    }))
  }

  clearElements(nodeData, dummy) {
    let children = []
    if (dummy) {
      children.push({name: 'Elements loading...'})
    }

    this.setState(state => ({
      treeData: changeNodeAtPath({
        treeData: state.treeData,
        path: nodeData.path,
        getNodeKey: this.getNodeKey,
        newNode: {...nodeData.node, children, expanded: false},
      }),
    }))
  }

  handleToggle(treeNodeData) {
    if (treeNodeData.expanded) {
      this.props.loadElements(treeNodeData.node.id).then((response) => {
        let nodeChildrens = this.decorateArrObject(response.data.elements.list)
        this.clearElements(treeNodeData)

        nodeChildrens.forEach(function (newNode) {
          this.addNodeToTree(treeNodeData.path, newNode)
        }, this)
      })
    }
    else {
      this.clearElements(treeNodeData, true)
    }
  }

  getNodeKey({treeIndex}) {
    return treeIndex
  }

  goToNodeProject(id) {
    this.props.history.push(`/projects/welds/${id}`)
  }

  refreshProjects() {
    this.props.data.refetch()
    let projects = this.props.data.projects.list.map(a => Object.assign({}, a))
    this.setState({treeData: this.decorateArrObject(projects), refresh: true})
  }

  render() {
    if (this.props.data.error) return <div>An unexpected error occurred</div>

    return (
      <BlockWithLoader loading={this.props.data.loading} renderChildren={false}>
        <div className="sortable-tree" style={{height: 600}}>
          <Button color="primary" onClick={this.refreshProjects}>Refresh <i className="fa fa-refresh"/></Button>
          <SortableTree
            theme={FileExplorerTheme}
            treeData={this.state.treeData}
            canDrag={false}
            onChange={treeData => this.setState({treeData})}
            onVisibilityToggle={this.handleToggle}
            getNodeKey={this.getNodeKey}
            generateNodeProps={({node}) => ({
              icons: node.isDirectory
                ? [
                  <div key='directory-project'
                    style={{
                      borderLeft: 'solid 8px #20a8d8',
                      borderBottom: 'solid 10px #20a8d8',
                      marginRight: 10,
                      width: 16,
                      height: 12,
                      filter: node.expanded
                        ? 'drop-shadow(1px 0 0 #1985ac) drop-shadow(0 1px 0 #1985ac) drop-shadow(0 -1px 0 #1985ac) drop-shadow(-1px 0 0 #1985ac)'
                        : 'none',
                      borderColor: node.expanded ? '#1985ac' : '#20a8d8',
                    }}
                  />,
                ]
                : [
                  <div key='leaf-project'
                    style={{
                      border: 'solid 1px #20a8d8',
                      color: '#20a8d8',
                      fontSize: 8,
                      textAlign: 'center',
                      marginRight: 10,
                      width: 12,
                      height: 16,
                    }}
                  >
                    E
                  </div>,
                ],

              title: (
                <div
                  className={'title-link'}
                  style={{fontSize: '1.1rem'}}
                  value={node.name}
                  onClick={() => this.goToNodeProject(node.id)}
                >
                  {node.name}
                </div>
              )
            })}
          />
        </div>
      </BlockWithLoader>
    )
  }
}

const ElementsFetchQuery = gql`
  query ElementsFetchQuery($parent_id: Int!) {
    elements(parent_id: $parent_id) {
      list {
        id
        name
        children_count
      }
    }
  }
`

const ProjectsFetchQuery = gql`
  query ProjectsFetchQuery {
    projects {
      list {
        id
        name
        children_count
      }
    }
  }
`

const ProjectsFetchData = graphql(
  ProjectsFetchQuery,
  {
    options: {fetchPolicy: 'network-only'},
    props({data: {loading, projects, fetchMore, refetch}}) {
      return {
        data: {
          loading,
          projects,
          refetch
        },
        loadElements(parent_id) {
          return fetchMore({
            query: ElementsFetchQuery,
            options: {fetchPolicy: 'network-only'},
            variables: {parent_id: Number(parent_id)},
            updateQuery: (previousResult) => {
              return {
                ...previousResult
              }
            }
          })
        }
      }
    },
  }
)(ProjectListTree)

export default ProjectsFetchData



// WEBPACK FOOTER //
// ./src/components/Projects/ProjectListTree.js